import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Article} from "../../../model/article";
import {NgIf} from "@angular/common";
import {Icons} from "../../../model/icon";
import {IconComponent} from "../icon/icon.component";
import {DeviceDetectorService} from "ngx-device-detector";
import {getImageUrl} from "../../../functions/getImageUrl";

@Component({
  selector: 'app-slider-item',
  imports: [
    NgIf,
    IconComponent
  ],
  templateUrl: './slider-item.component.html',
  styleUrl: './slider-item.component.scss'
})
export class SliderItemComponent implements OnInit {

  @Input() article: Article = new Article();
  @Input() backgroundContain: boolean = true;
  @Input() isMobile: boolean = true;
  @Output() scrolling = new EventEmitter();
  @Output() select = new EventEmitter();

  constructor(private deviceService: DeviceDetectorService) {}


  showContent: boolean = true;

  allowScroll(event: any) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('paragraph')) {
      this.scrolling.emit(true);
    } else {
      this.scrolling.emit(false);
    }
  }

  onChildTouch(event: TouchEvent, bool: boolean): void {
    event.stopPropagation(); // Останавливаем всплытие события
    this.scrolling.emit(bool);
  }

  ngOnInit() {
    this.isMobile = this.deviceService.isMobile();
  }


  activeImg: number = 0;

  clickImgs(k: number) {
    const length  = this.article.imgs?.length ?? 0;
    const idx = this.activeImg + k;
    if (idx < 0) {
      this.activeImg = length - 1;
    } else if (idx > length - 1) {
      this.activeImg = 0;
    } else {
      this.activeImg = idx;
    }
  }
  // getBackImage(vail?: boolean){
  //   if (this.article.imgs) {
  //     const vailStyle = vail ? 'background-color: rgba(0, 0, 0, 0.6); background-blend-mode: overlay;' : '';
  //     return `background-image: url(${this.article.imgs[this.activeImg]}); ${vailStyle}`;
  //   } else {
  //     const vailStyle = vail ? 'background-color: rgba(0, 0, 0, 0.6); background-blend-mode: overlay;' : '';
  //     return `background-image: url(${this.article.img}); ${vailStyle}`;
  //   }
  // }

  getBackImage(vail?: boolean){
    if (this.article.images !== undefined && this.article.images.length > 0) {
      const vailStyle = vail ? 'background-color: rgba(0, 0, 0, 0.6); background-blend-mode: overlay;' : '';
      let position;
      let size;
      if (this.isMobile) {
        position = this.article.mobilePosition ? `background-position: ${this.article.mobilePosition};` : '';
        size = this.article.mobileSize ? `background-size: ${this.article.mobileSize}; background-repeat: no-repeat;` : '';
      } else {
        position = this.article.position ? `background-position: ${this.article.position};` : '';
        size = this.article.size ? `background-size: ${this.article.size}; background-repeat: no-repeat;` : '';
      }
      return `background-image: url(${getImageUrl(this.article.images[this.activeImg])}); ${vailStyle} ${position} ${size}`;
    } else return '';
  }

  activeButtons() {
    if (this.article.imgs != undefined) {
      return this.article.imgs.length > 1 ;
    } else return false;
  }

  getClass() {
    if (this.backgroundContain) {
      return 'contain'
    } else  return 'cover'
  }

  selectHero(){
    this.select.emit();
  }

  protected readonly Icons = Icons;
  protected readonly getImageUrl = getImageUrl;
}
